/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePersonaDto } from '../../models/create-persona-dto';
import { PersonaResDto } from '../../models/persona-res-dto';

export interface PersoneControllerCreatePersona$Params {
  body: CreatePersonaDto;
}

export function personeControllerCreatePersona(
  http: HttpClient,
  rootUrl: string,
  params: PersoneControllerCreatePersona$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PersonaResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    personeControllerCreatePersona.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonaResDto>;
      }),
    );
}

personeControllerCreatePersona.PATH = '/admin/persona';
